import { render } from "./SortingToggle.vue?vue&type=template&id=5b49b47f&scoped=true"
import script from "./SortingToggle.vue?vue&type=script&lang=ts"
export * from "./SortingToggle.vue?vue&type=script&lang=ts"

import "./SortingToggle.vue?vue&type=style&index=0&id=5b49b47f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5b49b47f"

export default script